export const isClientError = (error: unknown): boolean => {
  const status = (error as any)?.response?.status;
  return typeof status === "number" && status >= 400 && status < 500;
};
